export default __webpack_public_path__ + "static/media/1.dba7a9e7.png";